import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Stempel from './Stempel';
import { Helmet } from 'react-helmet';

const Layout = () => {
  return (
    <div>
      <Helmet>
        {/* Базовые мета-теги, дублирующие index.html */}
        <title>Официальный сайт Сергея Мавроди</title>
        <meta
          name="description"
          content="Официальный сайт Сергея Мавроди: новости, творчество, видео, книги и архивные материалы."
        />
        <meta name="keywords" content="Сергей Мавроди, МММ, KinoTheater, новости, творчество, видео, книги, театр" />
        <meta property="og:title" content="Официальный сайт Сергея Мавроди" />
        <meta
          property="og:description"
          content="Новости, творчество, видео, книги и архивные материалы Сергея Мавроди."
        />
        <meta property="og:image" content="/portrait.webp" />
        <meta property="og:url" content="https://www.sergey-mavrodi.com" />
        <meta property="og:type" content="website" />
      </Helmet>
      <Header />
      <main>
        <Stempel>
          <Outlet />
        </Stempel>
      </main>
      <Footer />
    </div>
  );
};

export default Layout;